import React, { useEffect, useCallback, useState } from 'react';
import cls from './transactions.module.scss';
import { Col, Form, Row } from 'react-bootstrap';
import _ from 'lodash';
import { Icon } from 'lb-components';
import { Api, useTranslation } from 'lb-store';
import Moment from 'moment';
import { SlotIcon } from './icons';
import cx from 'classnames';
import 'moment/locale/ka';
/*import 'moment/locale/ru';
import 'moment/locale/en-au';*/

const Transactions = ({ setRoute }) => {
  const { t } = useTranslation();
  Moment.locale('ka');
  const [index, setIndex] = useState(0);
  const [transactions, setTransactions] = useState([]);

  const getTransactions = useCallback(() => {
    Api.User.TransactionHistory({
      from: document.getElementById('dateFrom').value,
      to: document.getElementById('dateTo').value,
    }).then((res) => {
      if (res.status) {
        setTransactions(res.data.data);
      }
    });
  }, []);

  useEffect(() => {
    getTransactions();
  }, []);
  return (
    <div className={cls.tab}>
      <div className={cls.tabBar}>
        <div className={cls.tabItem} onClick={() => setIndex(0)}>
          <span>{t('ყველა')}</span>
        </div>
        <div className={cls.tabItem} onClick={() => setIndex(1)}>
          <span>{t('შეტანა')}</span>
        </div>
        <div className={cls.tabItem} onClick={() => setIndex(2)}>
          <span>{t('გატანა')}</span>
        </div>
        <div
          className={cls.borderBottomActive}
          style={{ left: `calc(33% * ${index})`, width: `33%` }}
        />
      </div>
      <div className={cls.tabContent}>
        <div className={cls.calendar}>
          <Form style={{ flex: 1 }}>
            <Row>
              <Col style={{ maxWidth: '50%' }}>
                <Form.Group controlId='dateFrom'>
                  <Form.Label>{t('დან')}</Form.Label>
                  <Form.Control
                    type='date'
                    defaultValue={Moment(new Date())
                      .subtract(1, 'days')
                      .format('YYYY-MM-DD')}
                    className={cls.field}
                    onChange={getTransactions}
                    placeholder=''
                  />
                </Form.Group>
              </Col>
              <Col style={{ maxWidth: '50%' }}>
                <Form.Group controlId='dateTo'>
                  <Form.Label>{t('მდე')}</Form.Label>
                  <Form.Control
                    type='date'
                    defaultValue={Moment(new Date()).format('YYYY-MM-DD')}
                    className={cls.field}
                    onChange={getTransactions}
                    placeholder=''
                  />
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </div>
        <div className={cls.dataList}>
          {_.map(
            _.groupBy(
              _.filter(transactions, (tx) =>
                index ? tx.action === index : true
              ),
              (item) => Moment(new Date(item.EntryDate)).format('MM-DD-YYYY')
            ),
            (txs, title) => {
              return (
                <div key={title}>
                  <h3 className={cls.header}>{title}</h3>
                  <div className={cls.listContainer}>
                    {_.map(txs, (v, k) => {
                      //let title = v?.EntryType.split(':');
                      /*const splitIndex = v?.EntryType.indexOf(':');
                      let title = [
                        v?.EntryType.substring(0, splitIndex),
                        v?.EntryType.substring(splitIndex + 1),
                      ];*/
                      return (
                        <div key={k} className={cls.item}>
                          <div className={cls.icon}>
                            <Icon
                              Icon={SlotIcon}
                              width={'4rem'}
                              height={'4rem'}
                            />
                          </div>
                          <div className={cls.description}>
                            <div
                              dangerouslySetInnerHTML={{ __html: v?.EntryType }}
                            />
                            <span>{v?.EntryDate}</span>
                          </div>
                          <div
                            className={cx(cls.amount, {
                              [cls.red]: v.action === 2,
                              [cls.green]: v.action === 1,
                            })}
                          >
                            {v.Amount}₾
                            <br/>
                            <span>{t('ბალანსი')}: {v?.Balance}₾</span>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            }
          )}
        </div>
      </div>
    </div>
  );
};

export default Transactions;
